import { Theme } from '@mui/material';
import { Components } from '@mui/material/styles';
import keyFrames from 'theme/styles/keyFrames';
import popper from 'theme/styles/popper';
import reactFc from 'theme/styles/react-fc';
import simplebar from 'theme/styles/simplebar';
import vibrantNav from 'theme/styles/vibrantNav';

const CssBaseline: Components<Omit<Theme, 'components'>>['MuiCssBaseline'] = {
  defaultProps: {},
  styleOverrides: (theme) => ({
    '*': {
      scrollbarWidth: 'thin',
    },
    body: {
      scrollbarColor: `${theme.vars.palette.background.elevation4} transparent`,
      // fontFamily: (theme.typography && (theme.typography as any).fontFamily) || 'sans-serif',
      [`h1, h2, h3, h4, h5, h6, p`]: {
        margin: 0,
      },
      fontVariantLigatures: 'none',
      [`[id]`]: {
        scrollMarginTop: 82,
      },
    },
    ...simplebar(theme),
    ...keyFrames(),
    ...popper(theme),
    ...vibrantNav(theme),
    ...reactFc(theme),
  }),
};

export default CssBaseline;
